module.exports = __webpack_public_path__ + "img/world.5d91789e.jpg";